export default {"src":"/_next/static/media/PSX.0da4fffd.svg","height":18,"width":18};